import React from 'react'
import { Route, RouteComponentProps } from 'react-router'

import ResetPassword from './layout/ResetPassword'
import ResetPasswordEdit from './layout/ResetPasswordEdit'
import SignUp from './layout/SignUp'
import Confirmation from './layout/Confirmation'
import LoginContainer from './layout/LoginContainer'
import NotFoundWrapper from '../router/NotFoundWrapper'
import Login from './layout/Login'
import ExternalSignupSuccessful from './layout/ExternalSignupSuccessful'
import SignUpExternalOrganization, { ExternalOrganizationSignUpProps } from './layout/SignUpExternalOrganization'

// Local, permissive typings for untyped components to satisfy TS in this file only
const LoginContainerCustomTyped =
  LoginContainer as unknown as React.ComponentType<any>
const LoginCustomTyped = Login as unknown as React.ComponentType<any>
const SignUpCustomTyped = SignUp as unknown as React.ComponentType<any>
const ConfirmationCustomTyped =
  Confirmation as unknown as React.ComponentType<any>
const ResetPasswordCustomTyped =
  ResetPassword as unknown as React.ComponentType<any>
const ResetPasswordEditCustomTyped =
  ResetPasswordEdit as unknown as React.ComponentType<any>

interface AccountRoutesProps {
  resetPasswordProps: Record<string, any>
  resetPasswordEditProps: Record<string, any>
  loginProps: Record<string, any>
  signupProps: Record<string, any>
  confirmationProps: Record<string, any>
  externalOrganizationSignUpProps: ExternalOrganizationSignUpProps
  updateSession: (token: string | null) => void
  sessionToken: string | null
}

interface AccountRoutesState {
  targetHeight: string | number
  duration: number
}

export default class AccountRoutes extends React.Component<
AccountRoutesProps,
AccountRoutesState
> {
  state: AccountRoutesState = {
    targetHeight: 'auto',
    duration: 500
  }

  // Arrow function to preserve 'this' without needing .bind(this)
  setHeight = (targetHeight: string | number, duration = 500): void => {
    this.setState({ targetHeight, duration })
  }

  render (): React.ReactNode {
    const {
      resetPasswordProps,
      resetPasswordEditProps,
      loginProps,
      signupProps,
      confirmationProps,
      externalOrganizationSignUpProps
    } = this.props
    return (
      <NotFoundWrapper slug='account'>
        <Route
          exact
          path='(/login|/|/password|/password/edit|/confirmation|/signup|/signup-external-organization|/external-signup-successful)'
          render={(props: RouteComponentProps) => (
            <LoginContainerCustomTyped
              location={props.location}
              targetHeight={this.state.targetHeight}
              duration={this.state.duration}
              setHeight={this.setHeight}
            >
              <Route
                exact
                path='/signup'
                render={(props: RouteComponentProps) => (
                  <SignUpCustomTyped
                    {...props}
                    {...signupProps}
                    setHeight={this.setHeight}
                    targetHeight={this.state.targetHeight}
                  />
                )}
              />
              <Route
                exact
                path='/signup-external-organization'
                render={(props: RouteComponentProps) => (
                  <SignUpExternalOrganization
                    {...externalOrganizationSignUpProps}
                    {...props}
                    setHeight={this.setHeight}
                  />
                )}
              />
              <Route
                exact
                path='/external-signup-successful'
                render={() => (
                  <ExternalSignupSuccessful />
                )}
              />
              <Route
                exact
                path='/confirmation'
                render={(props: RouteComponentProps) => (
                  <ConfirmationCustomTyped
                    {...props}
                    {...confirmationProps}
                    setHeight={this.setHeight}
                    targetHeight={this.state.targetHeight}
                  />
                )}
              />
              <Route
                exact
                path='/password'
                render={(props: RouteComponentProps) => (
                  <ResetPasswordCustomTyped
                    {...props}
                    {...resetPasswordProps}
                    setHeight={this.setHeight}
                    targetHeight={this.state.targetHeight}
                  />
                )}
              />
              <Route
                exact
                path='/password/edit'
                render={(props: RouteComponentProps) => (
                  <ResetPasswordEditCustomTyped
                    {...props}
                    {...resetPasswordEditProps}
                    setHeight={this.setHeight}
                    targetHeight={this.state.targetHeight}
                  />
                )}
              />
              <Route
                exact
                path='(/login|/)'
                render={(props: RouteComponentProps) => (
                  <LoginCustomTyped
                    {...props}
                    {...loginProps}
                    signupProps={signupProps}
                    resetPasswordProps={resetPasswordProps}
                    updateSession={this.props.updateSession}
                    sessionToken={this.props.sessionToken}
                    setHeight={this.setHeight}
                    targetHeight={this.state.targetHeight}
                  />
                )}
              />
            </LoginContainerCustomTyped>
          )}
        />
      </NotFoundWrapper>
    )
  }
}
